
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/report",
      function () {
        return require("private-next-pages/csr/report.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/report"])
      });
    }
  